export enum BonusPaymentOption {
    BANK_DETAILS = "BankDetails",
    DECIDE_LATER = "DecideLater"
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/bonus-payment-option.enum.ts